module.exports = __webpack_public_path__ + "static/blob-debt-discharged-14876f40a658a0934e9f48b401537d15.png";